import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetVoucherTitlePipe } from './get-voucher-title.pipe';

@NgModule({
  declarations: [GetVoucherTitlePipe],
  imports: [CommonModule],
  exports: [GetVoucherTitlePipe],
})
export class GetVoucherTitlePipeModule {}
